import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import ShotDiagnosisScreen from './ShotDiagnosisScreen';
import VideoAnalysisScreen from './VideoAnalysisScreen';
import PremiumGate from '../components/PremiumGate';
import './GameAnalysisScreen.css';

const GameAnalysisScreen: React.FC = () => {
  const { currentSport } = useTheme();
  const [activeTab, setActiveTab] = useState<'shot-analysis' | 'video-analysis'>('shot-analysis');

  return (
    <div className="game-analysis-screen">
      <div className="container">
        <div className="analysis-header">
          <h1>Your Online Coach</h1>
          <p>Professional coaching without the cost—shot analysis, video feedback, and recovery plans for {currentSport.name}</p>
        </div>

        {/* Tab Navigation */}
        <div className="tab-navigation">
          <button
            className={`tab-button ${activeTab === 'shot-analysis' ? 'active' : ''}`}
            onClick={() => setActiveTab('shot-analysis')}
          >
            🎯 Shot Analysis
          </button>
          <button
            className={`tab-button ${activeTab === 'video-analysis' ? 'active' : ''}`}
            onClick={() => setActiveTab('video-analysis')}
          >
            📹 Video Analysis
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === 'shot-analysis' && (
            <div className="analysis-tab-content">
              <PremiumGate
                feature="Shot Analysis"
                description="Get personalized recommendations for improving your shots. Select shot types and issues for AI-enhanced coaching."
                benefits={[
                  { icon: '🎯', text: 'Shot-by-shot diagnosis' },
                  { icon: '🤖', text: 'AI-powered recommendations' },
                  { icon: '🏥', text: 'Injury prevention & recovery links' },
                  { icon: '📋', text: 'Common issues by sport' },
                ]}
              >
                <ShotDiagnosisScreen />
              </PremiumGate>
            </div>
          )}

          {activeTab === 'video-analysis' && (
            <div className="analysis-tab-content">
              <VideoAnalysisScreen />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameAnalysisScreen;
